export default __webpack_public_path__ + "static/media/p5.ceeb944c.jpg";